import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
export default (function (initialClasses, overloadClasses) {
  var overloadedPlugins = overloadClasses.split(" ").map(function (c) {
    return c.split("-")[0];
  });
  var filtered = initialClasses.split(" ").filter(function (c) {
    return !overloadedPlugins.some(function (o) {
      return c.startsWith(o);
    });
  });
  return filtered.join(" ");
});